import { Locale } from 'modules/i18n';

export const vrpcNoteTranslation = {
  [Locale.en]: {
    why: 'Every response is signed by an attested Intel TDX node, so you can prove it came from that node unchanged. Ankr Confidential RPC on the same endpoint also encrypts your request to the node.',
    how: 'Call it with @w3tech.io/vrpc-ethers or @w3tech.io/vrpc-viem: the SDK checks every response for you.',
    price:
      'Each request costs 3x the standard rate: 600 API credits ($0.00006) on EVM chains.',
    docs: 'Docs',
  },
};
